import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import theme from '@theme/FolxTheme';

interface IBillsRouteProps {
	children: ReactNode;
	path?: string;
}

const BillsLayout = styled(FlexColumn)`
	gap: ${theme.spacing.lg};
	max-width: 64rem;
	width: 100%;
`;

const BillsRoute: FC<IBillsRouteProps> = ({ children }) => {
	return <BillsLayout>{children}</BillsLayout>;
};

export default BillsRoute;
